import { Profile } from "@/app/auth/auth";
import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { RegistrationPayment } from "./registration-payments";
import { camelToSnake } from "caseparser";

export const registrationPaymentsApi = api
  .enhanceEndpoints({ addTagTypes: ["registrationPayments"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createRegistrationPayment: builder.mutation({
        query: ({ branchId, name, price, currency }) => ({
          url: `branchs/${branchId}/registration-payments`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            price,
            currency,
          }),
        }),
        invalidatesTags: ["registrationPayments"],
      }),
      updateRegistrationPayment: builder.mutation({
        query: ({ branchId, name, price, currency, id }) => ({
          url: `branchs/${branchId}/registration-payments/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            name,
            price,
            currency,
          }),
        }),
        invalidatesTags: ["registrationPayments"],
      }),
      deleteRegistrationPayment: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `branchs/${branchId}/registration-payments/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["registrationPayments"],
      }),
      registrationPayments: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/registration-payments`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) =>
          response.data.map(
            (registrationPayment: any): RegistrationPayment => ({
              id: registrationPayment.id,
              name: registrationPayment.name,
              currency: registrationPayment.currency,
              price: registrationPayment.price,
              createdAt: registrationPayment.created_at,
              updatedAt: registrationPayment.updated_at,
            })
          ),
        providesTags: ["registrationPayments"],
      }),
      getRegistrationPaymentCoursesFee: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/registration-payment-courses`,
          method: RequestMethod.GET,
        }),
      }),
      createMatriculateCourse: builder.mutation({
        query: ({ branchId, name, price, currency }) => ({
          url: `branchs/${branchId}/registration-payment-courses`,
          method: RequestMethod.POST,
          body: {
            name,
            price,
            currency,
          },
        }),
      }),
      updateMatriculateCourse: builder.mutation({
        query: ({ branchId, id, name, price, currency }) => ({
          url: `branchs/${branchId}/registration-payment-courses/${id}`,
          method: RequestMethod.PUT,
          body: { name, price, currency },
        }),
      }),
      getListMatriculateCourse: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/registration-payment-courses`,
          method: RequestMethod.GET,
        }),
      }),
    }),
  });

export const {
  useRegistrationPaymentsQuery,
  useCreateRegistrationPaymentMutation,
  useUpdateRegistrationPaymentMutation,
  useDeleteRegistrationPaymentMutation,
  useGetRegistrationPaymentCoursesFeeQuery,

  useCreateMatriculateCourseMutation,
  useUpdateMatriculateCourseMutation,
  useGetListMatriculateCourseQuery,
} = registrationPaymentsApi;
